module.exports = __webpack_public_path__ + "img/jhd.0638386f.png";